// extracted by mini-css-extract-plugin
export var fadeIn = "_8s-0";
export var panelInner = "_8s-2";
export var panelOuter = "_8s-1";